<app-layout-main [pageMetadata]="{ title: appName() }" [layoutSize]="'small'" [design]="'focused'">
	<lib-focused-card [title]="'Forgotten password'">
		@if (!formSubmitted()) {
		<ui-text-form-field
			[title]="'E-mail'"
			[isRequired]="true"
			[validation]="'email'"
			[valueAsSignal]="form.email"
			[maxLength]="50"
		></ui-text-form-field>

		<ui-form-save-button
			[title]="'Continue'"
			[saveHandler]="saveHandler()"
			[enableEnterSaveShortcut]="true"
			[logHandler]="formLogHandler()"
		></ui-form-save-button>
		} @else {
		<lib-message [type]="'success'"
			>We've sent e-mail to selected e-mail address if it exists. Please check your inbox to recover
			password</lib-message
		>
		}
	</lib-focused-card>
</app-layout-main>
